import { render, staticRenderFns } from "./PedidosPrincipal.vue?vue&type=template&id=5267ff21&scoped=true&"
import script from "./PedidosPrincipal.vue?vue&type=script&lang=js&"
export * from "./PedidosPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./PedidosPrincipal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PedidosPrincipal.vue?vue&type=style&index=1&id=5267ff21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267ff21",
  null
  
)

export default component.exports